module.exports = __webpack_public_path__ + "img/10-8.52d2df53.jpg";